<!-- eslint-disable vue/multi-word-component-names -->
<script>
export default {
  name: 'addressSearchField',
  props: {
    backgroundColor: {
      type: String,
      required: false,
      default: 'white',
    },
    boxTextTitle: {
      type: String,
      required: false,
      // default: "tw-w-[80%] tw-max-w-[80%]",
      default: '',
    },
    isShowSearchProp: {
      type: Boolean,
      required: false,
      default: false,
    },
    maxHeight_subMenu: {
      type: String,
      required: false,
      default: '200',
    },
    maxMinSearchProp: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    return {
      searchQuery: '',
      isLoading: false,
      isShowSearch: this.isShowSearchProp ?? false,
      locationList: [],
      locationLatLng: {
        lat: null,
        lng: null,
      },
      searchTimer: null,
      menuOpen: false,
    };
  },
  methods: {
    onSearchInput(value) {
      this.searchQuery = value;
      this.clearTimer();
      this.searchTimer = setTimeout(() => {
        if (this.searchQuery.trim().length > 2) {
          this.fetchBaseAddress();
        }
      }, 700);
      if (this.searchQuery.trim()) {
        this.locationList = [];
      }
    },
    clearTimer() {
      if (this.searchTimer) {
        clearTimeout(this.searchTimer);
        this.searchTimer = null;
      }
    },

    fetchBaseAddress: function () {
      if (!this.searchQuery.trim()) return;

      this.isLoading = true;
      this.$store
        .dispatch('getMapGeoCode', this.searchQuery)
        .then(() => {
          if (this.$store.state.mapModule.successFlag) {
            this.menuOpen = true;
            const geoCodeList = this.$store.state.mapModule.geoCode;
            this.locationList = geoCodeList ?? [];
          } else {
            if (this.$store.state.mapModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.fetchBaseAddress();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.mapModule.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.fetchBaseAddress();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            }
          }
        })
        .catch((error) => {
          console.error('Search error:', error);
          this.locationList = [];
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    selectLocation(item) {
      const newLatLng = {
        lat: item?.location?.latitude,
        lng: item?.location?.longitude,
      };
      this.locationLatLng = newLatLng;
      this.$emit('address-search', newLatLng);
      this.menuOpen = false;
    },
  },
  mounted() {
    this.clearTimer();
  },
  unmounted() {
    this.clearTimer();
  },
  beforeDestroy() {
    this.clearTimer();
  },
  // watch: {
  //   locationLatLng: function () {
  //     this.$emit('address-search', this.locationLatLng)
  //   },
  //   locationList: function () {
  //   }
  // }
};
</script>

<template>
  <v-menu v-model="menuOpen" bottom offset-y :close-on-content-click="false" :max-height="maxHeight_subMenu"
    transition="search-height-transition" :open-delay="100" :close-delay="100" attach z-index="10000"
    content-class="search-menu">
    <template v-slot:activator="{ on, attrs }">
      <div class="menu-activator-wrapper">
        <v-btn v-if="maxMinSearchProp && !isShowSearch" fab dense dark x-small class="search-button"
          @click="isShowSearch = true">
          <v-icon color="darkColor" size="24px">mdi-magnify</v-icon>
        </v-btn>
        <v-text-field v-else hide-details prepend-inner-icon="mdi-magnify" placeholder="مکان موردنظر را جستجو کنید"
          outlined :background-color="backgroundColor" rounded dense :loading="isLoading" :value="searchQuery"
          @input="onSearchInput" @keydown.enter="fetchBaseAddress" @mouseenter.stop="menuOpen = true" v-bind="attrs"
          v-on="on" class="searchBox custom-height-30">
          <!-- برای اعمال استایل‌های Tailwind روی div wrapper -->
          <template v-slot:default="{ attrs }">
            <div class="search-field-container" v-bind="attrs"></div>
          </template>
        </v-text-field>
        <v-btn v-if="maxMinSearchProp && isShowSearch" fab dense dark x-small class="close-button"
          @click="isShowSearch = false">
          <v-icon color="darkColor" size="20px">mdi-close</v-icon>
        </v-btn>
      </div>
    </template>

    <v-list class="pa-0 search-list-container search-list" :style="{ 'max-height': maxHeight_subMenu }">
      <v-list-item v-for="(item, index) in locationList" :key="index" class="location-list-item"
        @click="selectLocation(item)">
        <div class="marker-icon-wrapper">
          <i aria-hidden="true" class="v-icon notranslate mdi mdi-map-marker mdi-18px theme--light tw-text-white"></i>
        </div>
        <div class="location-info">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <p v-on="on" class="location-title" style="margin: 0">
                {{ item?.title ?? '' }}
              </p>
            </template>
            <span>{{ item?.title ?? '' }}</span>
          </v-tooltip>

          <p class="location-address" style="margin: 0">
            {{ item?.text ?? '' }}
          </p>
        </div>
      </v-list-item>

      <v-list-item v-if="locationList.length === 0 && searchQuery.length > 2 && !isLoading"
        class="tw-justify-center tw-text-gray-500">
        <!-- <span>نتیجه‌ای یافت نشد</span> -->
      </v-list-item>

      <v-list-item v-if="isLoading" class="tw-justify-center">
        <v-progress-circular indeterminate size="24" color="primary"></v-progress-circular>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<style scoped>
.menu-activator-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  gap: 0.25rem;
}

.search-button {
  width: 40px !important;
  height: 40px !important;
  background-color: #fff !important;
  transition: all 0.3s ease-in-out;
}

.search-button:hover {
  opacity: 0.8;
}

.search-field-container {
  max-width: 65% !important;
  width: 65% !important;
  flex: 1 1 auto;
}

.close-button {
  width: 24px !important;
  height: 24px !important;
  background-color: #fff !important;
}

.close-button:hover {
  opacity: 0.8;
}

.location-list-item {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 0.75rem;
  cursor: pointer;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  min-height: 56px;
  width: 100% !important;
  max-width: 100% !important;
  transition: all 0.2s ease;
}

.location-list-item:hover {
  background-color: #f3f4f6;
}

.marker-icon-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 26px;
  min-height: 26px;
  width: 26px;
  height: 26px;
  background-color: #e5e7eb;
  border-radius: 9999px;
}

.location-info {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 0.25rem;
  max-width: calc(100% - 40px);
  width: calc(100% - 40px);
}

.location-title {
  font-size: 0.875rem;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
}

.location-address {
  font-size: 0.75rem;
  color: #6b7280;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
}

.search-menu {
  animation-duration: 0.3s !important;
}

.search-list {
  overflow-y: auto;
}


/* >>> is for ::v-deep, which is deprecated. Using :deep() or nested selectors is preferred */
.searchBox :deep(.v-input__control .v-input__slot) {
  padding-inline: 10px !important;
}

.search-height-transition-enter-active,
.search-height-transition-leave-active {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
}

.search-height-transition-enter,
.search-height-transition-leave-to {
  max-height: 0 !important;
  opacity: 0;
  transform: translateY(-5px);
}

.search-height-transition-enter-to,
.search-height-transition-leave {
  max-height: 200px !important;
  opacity: 1;
  transform: translateY(0);
}
</style>

<style scoped>
.custom-height-30>>>.v-input__control {
  min-height: 30px !important;
  height: 30px !important;
}

.custom-height-30>>>.v-input__slot {
  min-height: 30px !important;
  height: 30px !important;
  padding: 0 12px !important;
}

.custom-height-30>>>.v-select__slot {
  height: 100% !important;
  align-items: center !important;
}

.custom-height-30>>>input {
  max-height: 26px !important;
  padding: 0 0 2px 0 !important;
  margin: 0 !important;
  font-size: 13px !important;
}

.custom-height-30>>>.v-input__append-inner,
.custom-height-30>>>.v-input__prepend-inner {
  margin-top: 0 !important;
  align-self: center !important;
  height: 100% !important;
  display: flex !important;
  align-items: center !important;
}

.custom-height-30>>>.v-input__slot label {
  top: 5px !important;
  font-size: 13px !important;
}

.custom-height-30.v-input--is-label-active>>>.v-input__slot label,
.custom-height-30.v-input--is-focused>>>.v-input__slot label {
  transform: translateY(-13px) scale(0.75) !important;
  background: white;
  padding: 0 4px !important;
}

.custom-height-30>>>.v-input__append-inner .v-icon {
  font-size: 18px !important;
}
</style>
